import { Flex, Spin } from 'antd'
import { useTranslation } from 'react-i18next'

import { useStyle } from './styles'

export const Loading = () => {
  const { styles } = useStyle()
  const { t } = useTranslation()

  return (
    <Flex
      align="center"
      justify="center"
      className={styles.fallback}
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={t('ui.loading')}
    >
      <Spin size="large" description={t('ui.loading')} />
    </Flex>
  )
}
